import request from '@/utils/request';
export const toggleEnable = (url, data) => request({
  url: url,
  method: 'patch',
  data
});
export const uploadFile = (data, url = '/common/upload', onUploadProgressCallBack) => request({
  url: url,
  method: 'post',
  data,
  onUploadProgress: onUploadProgressCallBack
});
export const getAppVersions = () => request({
  url: '/common/app_version',
  method: 'get'
});